var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7904 3.24982V6.3745C19.5003 7.28571 20.4104 8.66194 20.4104 10.8996L23.1428 12.4362V15.4279C21.9111 16.875 19.8572 18.0293 17.7904 18.7118V20.5714C17.7904 21.0447 17.4066 21.4286 16.9333 21.4286H14.1007C13.6274 21.4286 13.2436 21.0447 13.2436 20.5714V18.7118H7.62215V20.5714C7.62215 21.0447 7.23839 21.4286 6.765 21.4286H3.62342C3.27595 21.4286 2.96188 21.2205 2.8383 20.8956C1.54455 17.4962 0.530277 12.3649 2.11492 9.09051C3.26663 6.71072 5.14312 3.96428 12.9334 5.21026C13.7891 3.10289 16.0382 2.53678 17.2167 2.57304C17.5691 2.58387 17.7904 2.89718 17.7904 3.24982Z",
    fill: "#D7F4EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8573 10.978C16.6206 10.978 16.4287 10.7861 16.4287 10.5494C16.4287 10.3127 16.6206 10.1208 16.8573 10.1208",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8574 10.978C17.0941 10.978 17.286 10.7861 17.286 10.5494C17.286 10.3127 17.0941 10.1208 16.8574 10.1208",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5725 8.40339H8.39258",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.857422 4.7371C1.30699 5.94797 2.16157 6.8645 3.03397 7.51339",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7904 3.24982V6.3745C19.5003 7.28571 20.4104 8.66194 20.4104 10.8996L23.1428 12.4362V15.4279C21.9111 16.875 19.8572 18.0293 17.7904 18.7118V20.5714C17.7904 21.0447 17.4066 21.4286 16.9333 21.4286H14.1007C13.6274 21.4286 13.2436 21.0447 13.2436 20.5714V18.7118H7.62215V20.5714C7.62215 21.0447 7.23839 21.4286 6.765 21.4286H3.62342C3.27595 21.4286 2.96188 21.2205 2.8383 20.8956C1.54455 17.4962 0.530277 12.3649 2.11492 9.09051C3.26663 6.71072 5.14312 3.96428 12.9334 5.21026C13.7891 3.10289 16.0382 2.53678 17.2167 2.57304C17.5691 2.58387 17.7904 2.89718 17.7904 3.24982Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.b4fe35a8f3e089f785d7382a56dfba08.svg";
export { ForwardRef as ReactComponent };